export const errorMap = {
  keyExpired: 'account-activation-key-expired',
  invalidKey: 'account-invalid-activation-key',
  alreadyActivated: 'user-already-activated',
  notActivated: 'user-not-activated'
};
